import { isAuthenticated } from '@shared/utils/routerUtils';

export default [
  { path: '/user/me**', access: isAuthenticated() },
];
